<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import AdminForm from '@/components/admin/AdminForm.vue'
import AdminMissionPlanTemplateForm from '@/components/admin/missionPlanTemplate/AdminMissionPlanTemplateForm.vue'
import { AloDbMissionPlanTemplate } from '@/models/alodb/AloDbMissionPlanTemplate'

@Component({
  name: 'AdminMissionPlanTemplate', 
  components: {AdminMissionPlanTemplateForm},
  props:{
    itemid:{
      type:Number
    }
  }
})
export default class AdminMissionPlanTemplate extends AdminForm<AloDbMissionPlanTemplate> {  
  showDeleteAction:boolean  = true
  
  get itemTypeName(){
    return "MissionPlanTemplate"
  }

  get originalLibelle(){
    return this.original.MPT_LIBELLE
  }

  sauvegarde() {

    //@ts-ignore
    if(this.$refs.formComponent) this.$refs.formComponent.beforeSave()         
    //@ts-ignore
    //met à jour le mission plan
    this.$store.myActions.MISSIONPLANTEMPLATE_UPDATE_MODIFIED_ADM({
      //@ts-ignore
      MPT_JSON:JSON.stringify(this.$refs.formComponent.missionPlanUiState.missionPlan)
    })    
    .then(() => {
        this.$store.myActions.MISSIONPLANTEMPLATE_SAVE_REQUEST(null)
    })    
  }
}
</script>